// -----------------------------------------------------------------------------
// Channels the embedded store can invoke on the shell over the postMessage
// store bridge. The string values ARE the on-the-wire contract, shared by the
// sender (packages/website/src/services/overwolf/overwolf-store.service.ts) and
// the handler (packages/ow-app/src/desktop/store-bridge.ts) — see
// packages/ow-app/docs/overwolf-store-bridge.md for the full message contract.
// -----------------------------------------------------------------------------

export enum BridgeChannel {
  Ping = 'Ping',
  GetInstalledApps = 'GetInstalledApps',
  InstallApp = 'installApp',
  UninstallApp = 'UninstallApp',
  LaunchApp = 'launchApp',
  Logout = 'Logout',
  GetUserProfileDetails = 'GetUserProfileDetails',
  DownloadApp = 'DownloadApp',
  GetInstalledElectronApps = 'GetInstalledElectronApps',
  IsElectronAppInstalled = 'IsElectronAppInstalled',
  LaunchElectron = 'LaunchElectron',
  GetMachineName = 'GetMachineName',
  Track = 'Track',
  OpenSettings = 'OpenSettings',
  PlaceOnClipboard = 'PlaceOnClipboard',
}

// UTM/attribution params, matching the native URLParams DTO (see
// OverWolf.Client.CommonUtils.OverwolfAPI.DTOs.URLParams in the client repo).
export interface OverwolfUtmParams {
  source?: string;
  medium?: string;
  campaign?: string;
  term?: string;
  content?: string;
}

// -----------------------------------------------------------------------------
// The 3rd argument the native `OverwolfStore.apps.installApp` call accepts,
// used by the client for its own install-source analytics (independent of this
// repo's tracking). Built entirely on the store side (see
// use-download-click-handler) and forwarded unchanged through the bridge and
// the shell to the native call.
export interface OverwolfInstallOrigin {
  // The path of the page the install was triggered from.
  page?: string;
  // True when the app page was reached via a homepage carousel slide click.
  fromCarousel?: boolean;
  // True when the install was triggered from the app detail page, false when
  // triggered directly from a shelf tile.
  isOneApp?: boolean;
  // Name of the shelf the triggering tile belongs to (shelf tiles only).
  shelf?: string;
  // UTM params present on the triggering page's URL (utm_source, utm_medium,
  // utm_campaign, utm_term, utm_content), for the client's install analytics.
  utmParams?: OverwolfUtmParams;
  // Index signature so this satisfies the native binding's loosely-typed 3rd
  // argument (see OverwolfStoreApps.installApp in ow-app/src/global.d.ts).
  [key: string]: unknown;
}
